import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1059c084")

_pushScopeId("data-v-1059c084")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("WeTrade Cup")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("My Prize")
const _hoisted_3 = { class: "flex-1 wt-cup scroll-y" }
const _hoisted_4 = {
  class: "time df-col df-middle",
  style: {"padding-top":"100px"}
}
const _hoisted_5 = { class: "season" }
const _hoisted_6 = { class: "date df-middle mt-6" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "date-l" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode("April 1- June 30")
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "date-r" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_t = _resolveComponent("t")
  const _component_router_link = _resolveComponent("router-link")
  const _component_Icon = _resolveComponent("Icon")
  const _component_TheCupTabSwitch = _resolveComponent("TheCupTabSwitch")
  const _component_ThePrizeCategory = _resolveComponent("ThePrizeCategory")
  const _component_TheTopTraders = _resolveComponent("TheTopTraders")
  const _component_PageWithHeader = _resolveComponent("PageWithHeader")

  return (_openBlock(), _createBlock(_component_PageWithHeader, null, {
    title: _withId(() => [
      _createVNode(_component_t, { path: "cup_2" }, {
        default: _withId(() => [
          _hoisted_1
        ]),
        _: 1
      })
    ]),
    right: _withId(() => [
      _createVNode(_component_router_link, { to: "/cup/wt/myprize" }, {
        default: _withId(() => [
          _createVNode(_component_t, {
            class: "t-r f-md",
            path: "cup_3"
          }, {
            default: _withId(() => [
              _hoisted_2
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_Icon, {
        name: "close",
        class: "c-title anchor",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.back()))
      })
    ]),
    body: _withId(() => [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_t, { path: "cup_4" })
          ]),
          _createVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_t, {
              class: "date-m",
              path: "cup_5"
            }, {
              default: _withId(() => [
                _hoisted_8
              ]),
              _: 1
            }),
            _hoisted_9
          ])
        ]),
        _createVNode(_component_TheCupTabSwitch, {
          tabs: [_ctx.translate('cup_6'), _ctx.translate('cup_7')],
          style: {"margin-bottom":"40px"},
          onSwitch: _cache[2] || (_cache[2] = ($event: any) => (_ctx.usePrizeView = !_ctx.usePrizeView)),
          home: ""
        }, null, 8, ["tabs"]),
        (_ctx.usePrizeView)
          ? (_openBlock(), _createBlock(_component_ThePrizeCategory, { key: 0 }))
          : (_openBlock(), _createBlock(_component_TheTopTraders, { key: 1 }))
      ])
    ]),
    _: 1
  }))
})